<template>
  <div id="app" :class="{locked: isLocked}">
    <x-loader v-if="isLocked"/>
    <router-view></router-view>
    <!--<page-footer/>-->
    <cookies/>
  </div>
</template>
<script>
  import pageFooter from './components/PageFooter.vue'
  import sideMenu from './components/SideMenu.vue'
  import xLoader from './components/Loader.vue'
  import cookies from './components/Cookies.vue'
  import { EventBus } from './components/EventBus.js';

  export default {
    name: 'app',
    components: {
      'page-footer': pageFooter,
      'side-menu': sideMenu,
      'x-loader': xLoader,
      'cookies': cookies
    },
    data () {
      return {
        isLocked: false
      }
    },
    mounted () {
      var self = this;
      EventBus.$on('lock-interaction', function() {
        self.isLocked = true;
      });
      EventBus.$on('unlock-interaction', function() {
        self.isLocked = false;
      });
    }
  };
</script>
<style>

.locked {
  pointer-events: none;
}
* {
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Source Sans Pro",HelveticaNeue-Light,"Helvetica Neue Light","Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif;
  -webkit-margin-before: 0px;
  -webkit-margin-after: 0px;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  -webkit-padding-start: 0px;
}
ul {
  -webkit-padding-start: 20px;
}
body {
  padding: 0;
  margin: 0;
}
b {
  font-weight: 600;
}
h1, h2 {
  font-weight: normal;
}
h1 {
  padding: 20px 0;
  color: #ef3d23;
}
.page {
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 40px;
  overflow-x: hidden;
  text-align: center;
}
.page.wide {
  max-width: 100%;
  padding: 0;
}
.page.wide .content {
  width: 100%;
  float: left;
}
.page main {
  float: left;
  width: 100%;
}
.content {
  padding-top: 20px;
  padding-bottom: 40px;
}
a {
  text-decoration: none;
  color: inherit;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    opacity: 0.7; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    opacity: 0.7;
}

::-ms-input-placeholder { /* Microsoft Edge */
    opacity: 0.7;
}
@media (max-width: 520px) {
  .page {
    padding: 0 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue